import { render, staticRenderFns } from "./PopupFiltersDocuments.vue?vue&type=template&id=966d92bc"
import script from "./PopupFiltersDocuments.vue?vue&type=script&lang=ts"
export * from "./PopupFiltersDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports